/* Nomari · Custom Order 訂製查詢 (brief inquiry) — added 2026-09-30
   Writes to Site Data:
     ./.herenow/data/custom_inquiry_images  (one compressed image per record, ≤ ~15 KB data URL)
     ./.herenow/data/custom_inquiries       (the inquiry itself; written last)
   Both collections: insert public, read owner only (see .herenow/data.json). */
(function(){
  "use strict";
  var C = window.NOMARI_CONFIG || {}, CO = C.customOrder;
  if (!CO) return;
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var esc = function(s){ return String(s == null ? "" : s).replace(/[&<>"']/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); };
  var params = new URLSearchParams(location.search);
  var IS_TEST = params.get("test") === "1";
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE_RE = /^(?=(?:\D*\d){7,})[+()\-\s.0-9]{7,30}$/;   // ≥7 digits (2026-10-03)
  // M2/M3/M5 (2026-10-03): messages, button labels and done-screen labels in the current language only
  function isEn(){ return !!(window.NomariI18n && window.NomariI18n.current() === "en"); }
  function L(zh, en){ return isEn() ? en : zh; }
  function mixed(s){ return window.NomariI18n ? window.NomariI18n.displayMixed(s) : String(s == null ? "" : s); }
  var IG_RE = /^[A-Za-z0-9._]{1,30}$/;
  var MAX_IMG = CO.maxImages || 3;
  var MAX_DATAURL = 15000;          // Site Data record body limit is 16 KB
  var MAX_SRC_BYTES = 25 * 1024 * 1024;
  function asset(src, ext){ return C.assetUrl ? C.assetUrl(src, ext) : src + ext; }

  // ---------- view switching (tabs) ----------
  var vPre = $("#viewPreorder"), vCus = $("#viewCustom");
  var tabs = document.querySelectorAll(".tabs .tab");
  function setView(v, scroll){
    var custom = v === "custom";
    // Home / Pre-order tabs are routed by app.js since the home page (2026-10-02): "home" → bare URL, "preorder" → ?view=shop
    if (!custom && window.NomariNav){ window.NomariNav.go(v); return; }
    vPre.hidden = custom; vCus.hidden = !custom;
    Array.prototype.forEach.call(tabs, function(t){ t.setAttribute("aria-selected", String(t.getAttribute("data-view") === v)); });
    var p = new URLSearchParams(location.search);
    if (custom) p.set("view", "custom"); else p.delete("view");
    var qs = p.toString();
    try { history.replaceState(history.state, "", location.pathname + (qs ? "?" + qs : "") + (custom ? "" : location.hash.replace("#custom",""))); } catch(e){}
    document.title = custom ? (window.NomariI18n ? window.NomariI18n.customTitle() : "nomari · 訂製查詢") : (window.NomariI18n ? window.NomariI18n.catalogTitle() : "nomari · 預訂");
    if (scroll !== false) window.scrollTo(0, 0);
  }
  Array.prototype.forEach.call(tabs, function(t){
    t.addEventListener("click", function(){ setView(t.getAttribute("data-view")); });
  });
  document.addEventListener("click", function(e){
    var a = e.target.closest("[data-goview]"); if (!a) return;
    e.preventDefault(); setView(a.getAttribute("data-goview"));
  });
  window.NomariCustomView = setView;
  if (params.get("view") === "custom" || location.hash === "#custom") setView("custom", false);

  // ---------- render static bits ----------
  var form = $("#customForm");
  $("#cTypes").innerHTML = CO.types.map(function(t){
    return '<label class="chip"><input type="checkbox" name="c_type" value="'+esc(t.id)+'"><span>'+esc(t.name)+'</span></label>';
  }).join("");
  $("#c-budget").innerHTML = CO.budgets.map(function(b){
    return '<option value="'+esc(b.id)+'">'+esc(b.name)+'</option>';
  }).join("");
  var maxImgEl = $("#cMaxImg"); if (maxImgEl) maxImgEl.textContent = MAX_IMG;
  (function(){ var d = new Date(); $("#c-date").min = d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0"); })();

  function typeName(id){ var t = CO.types.filter(function(x){ return x.id === id; })[0]; return t ? t.name : id; }
  function budgetName(id){ var b = CO.budgets.filter(function(x){ return x.id === id; })[0]; return b ? b.name : id; }
  function checkedTypes(){ return Array.prototype.map.call(form.querySelectorAll('input[name=c_type]:checked'), function(i){ return i.value; }); }
  // 例子 Example galleries: always shown for types that have example photos (e.g. Business logo stand);
  // the gallery of a type is highlighted when that type is ticked.
  function exPic(src, alt, big){   // big = lightbox: original full-size file, no srcset/size attributes (unchanged)
    if (window.NomariImg && !big) return window.NomariImg.picture(src, alt, {sizes: "(min-width:560px) 152px, 25vw", near: true});   // responsive 600w srcset (2026-10-02 perf)
    return '<picture><source type="image/webp" srcset="'+esc(asset(src, '.webp'))+'"><img src="'+esc(asset(src, '.jpg'))+'" alt="'+esc(alt||"")+'" loading="lazy" decoding="async"></picture>';
  }
  function renderExamples(){
    var checked = checkedTypes();
    $("#cExamples").innerHTML = CO.types.filter(function(t){ return t.examples && t.examples.length; }).map(function(t){
      return '<div class="c-examples'+(checked.indexOf(t.id) >= 0 ? ' on' : '')+'" data-ex-type="'+esc(t.id)+'">' +
        '<p class="c-examples-h"><span class="ex-tag">例子 Example</span>'+esc(t.name)+'</p><div class="ex-grid">' +
        t.examples.map(function(x, i){
          return '<button type="button" class="ex-item" data-ex="'+esc(t.id)+'|'+i+'"><div class="ex-img"'+(t.examplesRatio ? ' style="aspect-ratio:'+esc(t.examplesRatio)+'"' : '')+'>'+exPic(x.photo, x.alt)+'</div><small>'+esc(x.caption||"")+'</small></button>';
        }).join("") + '</div></div>';
    }).join("");
    if (window.NomariImg) window.NomariImg.watch($("#cExamples"));   // example photos load when near the viewport (2026-10-02 perf)
  }
  renderExamples();
  if (window.NomariI18n) window.NomariI18n.apply();
  document.addEventListener("click", function(e){
    var b = e.target.closest("[data-ex]");
    if (b){
      var p = b.getAttribute("data-ex").split("|"), t = CO.types.filter(function(x){ return x.id === p[0]; })[0], x = t && t.examples[+p[1]];
      if (!x) return;
      var lb = document.createElement("div"); lb.className = "ex-lb"; lb.setAttribute("role", "dialog");
      lb.innerHTML = exPic(x.photo, x.alt, true) + '<p>例子 Example · '+esc(t.name)+' · '+esc(x.caption||"")+'</p><button type="button">關閉 Close</button>';
      lb.addEventListener("click", function(ev){ if (ev.target === lb || ev.target.tagName === "BUTTON") lb.remove(); });
      document.body.appendChild(lb);
    }
  });
  form.addEventListener("change", function(e){
    if (e.target.name === "c_type"){
      $("#cOtherField").hidden = checkedTypes().indexOf("other") < 0;
      var checked = checkedTypes();
      Array.prototype.forEach.call(document.querySelectorAll("[data-ex-type]"), function(el){ el.classList.toggle("on", checked.indexOf(el.getAttribute("data-ex-type")) >= 0); });
    }
  });

  // ---------- images: client-side compression ----------
  var images = [];   // {key, file_name, mime, width, height, data_url}
  var busy = 0;
  var WEBP_OK = (function(){ try { var c = document.createElement("canvas"); c.width = c.height = 1; return c.toDataURL("image/webp").indexOf("data:image/webp") === 0; } catch(e){ return false; } })();

  function loadImg(file){
    return new Promise(function(res, rej){
      var url = URL.createObjectURL(file), im = new Image();
      im.onload = function(){ res({im: im, url: url}); };
      im.onerror = function(){ URL.revokeObjectURL(url); rej(new Error("decode")); };
      im.src = url;
    });
  }
  function draw(im, w, h, bg){
    var c = document.createElement("canvas"); c.width = w; c.height = h;
    var x = c.getContext("2d");
    if (bg){ x.fillStyle = bg; x.fillRect(0, 0, w, h); }
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = "high";
    x.drawImage(im, 0, 0, w, h);
    return c;
  }
  // Largest size (≤1000px long edge) that fits in one Site Data record.
  function compress(im, srcType){
    var W = im.naturalWidth, H = im.naturalHeight;
    if (!W || !H) return null;
    var maybeAlpha = /png|gif|webp|svg/.test(srcType || "");
    var dims = [1000, 900, 800, 720, 640, 560, 480, 420, 360, 300, 240, 180];
    var lastW = 0;
    for (var d = 0; d < dims.length; d++){
      var s = Math.min(1, dims[d] / Math.max(W, H));
      var w = Math.max(1, Math.round(W * s)), h = Math.max(1, Math.round(H * s));
      if (w === lastW) continue;   // small source: this size was already tried
      lastW = w;
      var c = draw(im, w, h, null), out;
      if (maybeAlpha){ out = c.toDataURL("image/png"); if (out.length <= MAX_DATAURL) return {url: out, mime: "image/png", w: w, h: h}; }
      var qs = [0.8, 0.65, 0.5, 0.38, 0.28];
      if (WEBP_OK){
        for (var i = 0; i < qs.length; i++){ out = c.toDataURL("image/webp", qs[i]); if (out.indexOf("data:image/webp") === 0 && out.length <= MAX_DATAURL) return {url: out, mime: "image/webp", w: w, h: h}; }
      }
      var cj = draw(im, w, h, "#FFFFFF");
      for (var j = 0; j < qs.length; j++){ out = cj.toDataURL("image/jpeg", qs[j]); if (out.length <= MAX_DATAURL) return {url: out, mime: "image/jpeg", w: w, h: h}; }
    }
    return null;
  }
  function renderThumbs(){
    var html = images.map(function(img, i){
      return '<div class="thumb"><img src="'+esc(img.data_url)+'" alt="'+esc(img.file_name)+'">' +
        '<button type="button" class="rm" data-rm="'+i+'" aria-label="移除 Remove">×</button>' +
        '<small>'+img.width+'×'+img.height+' · '+Math.round(img.data_url.length*0.75/1024)+'KB</small></div>';
    }).join("");
    for (var b = 0; b < busy; b++) html += '<div class="thumb busy">壓縮中… Compressing</div>';
    $("#cThumbs").innerHTML = html;
    $(".upload-btn").classList.toggle("disabled", images.length + busy >= MAX_IMG);
  }
  function imagesChanged(){ if (uploaded.length){ draftRef = null; uploaded = []; } }
  $("#c-files").addEventListener("change", function(e){
    var files = Array.prototype.slice.call(e.target.files || []);
    e.target.value = "";
    var room = MAX_IMG - images.length - busy, msgs = [];
    if (files.length > room){ msgs.push("最多 " + MAX_IMG + " 張 · Max " + MAX_IMG + " images"); files = files.slice(0, Math.max(0, room)); }
    setErr("c_files", msgs.join(" "));
    files.forEach(function(f){
      if (!/^image\//.test(f.type || "") && !/\.(jpe?g|png|gif|webp|heic|heif)$/i.test(f.name || "")){ setErr("c_files", "只可以上載圖片 · Images only"); return; }
      if (f.size > MAX_SRC_BYTES){ setErr("c_files", "張相太大（最多 25MB）· Image too large"); return; }
      busy++; renderThumbs();
      loadImg(f).then(function(r){
        var out = compress(r.im, f.type); URL.revokeObjectURL(r.url);
        if (!out) throw new Error("toolarge");
        images.push({key: Math.random().toString(36).slice(2), file_name: (f.name || "image").slice(0, 120), mime: out.mime, width: out.w, height: out.h, data_url: out.url});
        imagesChanged();
      }).catch(function(){
        setErr("c_files", "呢張相讀唔到，請用 JPG／PNG，或者 IG DM " + CO.igHandle + " · Couldn’t read this image, try JPG/PNG or DM us on IG");
      }).then(function(){ busy--; renderThumbs(); });
    });
  });
  $("#cThumbs").addEventListener("click", function(e){
    var b = e.target.closest("[data-rm]"); if (!b) return;
    images.splice(parseInt(b.getAttribute("data-rm"), 10), 1); imagesChanged(); renderThumbs(); setErr("c_files", "");
  });

  // ---------- validation ----------
  function setErr(key, msg){ var el = form.querySelector('.err[data-for="'+key+'"]'); if (el) el.textContent = msg || ""; }
  function val(n){ var el = form.elements[n]; return el ? String(el.value || "").trim() : ""; }
  function validate(){
    var errs = {}, types = checkedTypes();
    var other = val("product_other"), desc = val("description"), name = val("name");
    var email = val("email"), ig = val("ig").replace(/^@+/, ""), phone = val("phone"), date = val("wanted_by");
    if (!types.length) errs.c_types = L("請揀最少一項", "Choose at least one");
    if (types.indexOf("other") >= 0 && !other) errs.c_other = L("請講低係咩產品", "Please describe");
    if (desc.length < 3) errs.c_desc = L("請簡單講下用途", "Please describe what you need");
    if (!name) errs.c_name = L("請填寫名", "Name is required");
    if (!email && !ig && !phone) errs.c_contact = L("電郵、IG 或電話最少填一項", "Email, IG or phone required");
    else if (email && !EMAIL_RE.test(email)) errs.c_contact = L("電郵格式唔啱", "Invalid email");
    else if (ig && !IG_RE.test(ig)) errs.c_contact = L("IG 名格式唔啱", "Invalid IG handle");
    else if (phone && !PHONE_RE.test(phone)) errs.c_contact = L("電話格式唔啱", "Invalid phone");
    if (date && !/^\d{4}-\d{2}-\d{2}$/.test(date)) errs.c_date = L("日期格式唔啱", "Invalid date");
    ["c_types","c_other","c_desc","c_name","c_contact","c_date"].forEach(function(k){ setErr(k, errs[k]); });
    $("#cTypes").classList.toggle("invalid-group", !!errs.c_types);
    $("#c-other").classList.toggle("invalid", !!errs.c_other);
    $("#c-desc").classList.toggle("invalid", !!errs.c_desc);
    $("#c-name").classList.toggle("invalid", !!errs.c_name);
    ["#c-email","#c-ig","#c-phone"].forEach(function(s){ $(s).classList.toggle("invalid", !!errs.c_contact); });
    if (Object.keys(errs).length) return null;
    var rec = {
      product_types: types.join(","),
      product_labels: types.map(typeName).join(" · ").slice(0, 300),
      description: desc, name: name,
      is_test: IS_TEST, source: "custom-web-v1"
    };
    if (types.indexOf("other") >= 0) rec.product_other = other;
    var size = val("size"), colour = val("colour"), qty = val("quantity"), budget = val("budget");
    if (size) rec.size = size;
    if (colour) rec.colour = colour;
    if (qty) rec.quantity = qty;
    if (budget) rec.budget = budgetName(budget);
    if (date) rec.wanted_by = date;
    if (email) rec.email = email;
    if (ig) rec.ig = "@" + ig;
    if (phone) rec.phone = phone;
    return rec;
  }
  var tried = false;
  form.addEventListener("input", function(){ if (tried) validate(); });
  form.addEventListener("change", function(){ if (tried) validate(); });

  // ---------- submit ----------
  function makeRef(){
    var d = new Date(), A = "23456789ABCDEFGHJKMNPQRSTUVWXYZ", s = "";
    var buf = new Uint32Array(4); crypto.getRandomValues(buf);
    for (var i = 0; i < 4; i++) s += A[buf[i] % A.length];
    return "CU" + String(d.getMonth()+1).padStart(2,"0") + String(d.getDate()).padStart(2,"0") + "-" + s;
  }
  function uuid(){ return crypto.randomUUID ? crypto.randomUUID() : (Date.now() + "-" + Math.random().toString(36).slice(2)); }
  var draftRef = null, uploaded = [], inquiryKey = null, lastBody = null, lastKeyUsed = null, submittedAt = null;
  function post(coll, body, key){
    return fetch("./.herenow/data/" + coll, {
      method: "POST",
      headers: {"content-type": "application/json", "Idempotency-Key": key},
      body: JSON.stringify(body)
    }).then(function(r){
      return r.json().catch(function(){ return {}; }).then(function(j){ if (!r.ok) throw {status: r.status, j: j}; return j; });
    });
  }
  form.addEventListener("submit", function(e){
    e.preventDefault(); tried = true; $("#cFormErr").textContent = "";
    if (busy){ $("#cFormErr").textContent = L("相片仲壓縮緊，請等等", "Images still compressing, please wait"); return; }
    var rec = validate();
    if (!rec){ var first = form.querySelector(".err:not(:empty)"); if (first) first.parentNode.scrollIntoView({behavior: "smooth", block: "center"}); return; }
    if (!draftRef){ draftRef = makeRef(); uploaded = []; inquiryKey = null; lastBody = null; }
    rec.ref = draftRef;
    var btn = $("#cSubmitBtn"); btn.disabled = true;
    var queue = images.map(function(img, i){ return {img: img, idx: i + 1}; }).filter(function(q){ return uploaded.indexOf(q.img.key) < 0; });
    var chain = Promise.resolve();
    queue.forEach(function(q, n){
      chain = chain.then(function(){
        btn.textContent = L("上載相片 ", "Uploading images ") + (images.length - queue.length + n + 1) + "/" + images.length + "…";
        return post("custom_inquiry_images", {
          ref: draftRef, idx: q.idx, file_name: q.img.file_name, mime: q.img.mime,
          width: q.img.width, height: q.img.height, data_url: q.img.data_url, is_test: IS_TEST
        }, draftRef + "-img-" + q.idx + "-" + q.img.key).then(function(){ uploaded.push(q.img.key); });
      });
    });
    chain.then(function(){
      btn.textContent = L("提交緊…", "Sending…");
      rec.image_count = images.length;
      var body = JSON.stringify(rec);
      if (!inquiryKey || body !== lastBody){ inquiryKey = uuid(); lastBody = body; }  // same key only for an identical retry
      if (inquiryKey !== lastKeyUsed){ submittedAt = new Date().toISOString(); lastKeyUsed = inquiryKey; }
      rec.submitted_at = submittedAt;
      return post("custom_inquiries", rec, inquiryKey);
    }).then(function(){
      showDone(rec);
      draftRef = null; uploaded = []; inquiryKey = null;
    }).catch(function(res){
      var msg = window.NomariI18n && window.NomariI18n.current()==="en" ? "Couldn’t send your inquiry. Please try again, or DM us on Instagram @nomari.studio." : "提交唔到，請再試，或者 IG DM " + CO.igHandle + "。";
      if (res && res.status === 429) msg = window.NomariI18n && window.NomariI18n.current()==="en" ? "Too many attempts. Please wait a moment, or DM us on Instagram @nomari.studio." : "試得太密，請等陣再試，或者 IG DM " + CO.igHandle + "。";
      else if (res && res.status === 400){ console.warn("Custom inquiry 400:", res.j && (res.j.message || res.j.error || res.j)); msg = window.NomariI18n && window.NomariI18n.current()==="en" ? "Something’s not right. Please check your details and try again." : "資料有誤，請檢查資料後再試。"; }
      else if (res && res.status === 413) msg = window.NomariI18n && window.NomariI18n.current()==="en" ? "Images too large. Remove one or two and try again." : "相片太大，請刪走一兩張再試。";
      $("#cFormErr").textContent = msg;
    }).then(function(){ btn.disabled = false; btn.textContent = "提交查詢 Send inquiry"; if (window.NomariI18n) window.NomariI18n.apply(); });   // M3: original text + apply() → one language
  });

  // M4/M5 (2026-10-03): labels + our own option names in the current language; what the customer typed (description, size, colour,
  // other, name, contact) is shown verbatim and marked data-i18n-skip so i18n.apply never splits it. Re-rendered on zh/en toggle.
  var lastDone = null;
  function renderDoneSummary(rec){
    var types = String(rec.product_types || "").split(",").filter(Boolean).map(function(id){ return mixed(typeName(id)); }).join(" · ") || rec.product_labels;
    var rows = [
      [L("類型", "Type"), types + (rec.product_other ? (isEn() ? " (" + rec.product_other + ")" : "（" + rec.product_other + "）") : "")],
      [L("簡述", "Description"), rec.description],
      rec.size ? [L("尺寸", "Size"), rec.size] : null,
      rec.colour ? [L("顏色", "Colour"), rec.colour] : null,
      rec.quantity ? [L("數量", "Quantity"), rec.quantity] : null,
      rec.budget ? [L("預算", "Budget"), mixed(rec.budget)] : null,
      rec.wanted_by ? [L("想幾時有", "Wanted by"), rec.wanted_by] : null,
      rec.image_count ? [L("圖片", "Images"), rec.image_count + L(" 張", rec.image_count === 1 ? " image" : " images")] : null,
      [L("名", "Name"), rec.name],
      [L("聯絡", "Contact"), [rec.email, rec.ig, rec.phone].filter(Boolean).join(" / ")]
    ].filter(Boolean);
    $("#cSummary").innerHTML = rows.map(function(r){ return "<div data-i18n-skip><span>"+esc(r[0])+"</span><span class=\"done-val\">"+esc(r[1])+"</span></div>"; }).join("");
  }
  if (window.NomariI18n){ var prevApply = window.NomariI18n.onApply; window.NomariI18n.onApply = function(){ if (prevApply) prevApply(); if (lastDone && !$("#cDone").hidden) renderDoneSummary(lastDone); }; }
  function showDone(rec){
    $("#cRef").innerHTML = esc(rec.ref) + (rec.is_test ? '<span class="test-flag">TEST</span>' : "");
    lastDone = rec; renderDoneSummary(rec);
    $("#custom").hidden = true; $("#cHero").hidden = true; $("#cDone").hidden = false; window.scrollTo(0, 0);
  }
  $("#cAgainBtn").addEventListener("click", function(){
    tried = false; form.reset(); images = []; renderThumbs();
    $("#cOtherField").hidden = true; renderExamples();
    form.querySelectorAll(".err").forEach(function(el){ el.textContent = ""; });
    $("#cDone").hidden = true; $("#custom").hidden = false; $("#cHero").hidden = false; window.scrollTo(0, 0);
  });
})();
